export const formatRewardName = (rewardName: string) => {
  const cleanName = rewardName
    .replace(/\s*PM\s+балл(ов|ы)\s*/gi, "")
    .replace(/\s*балл(ов|ы)\s+PM\s+PASS\s*/gi, "")
    .replace(/\s*PM\s+PASS\s*/gi, "")
    .replace(/\s*балл(ов|ы)\s*/gi, "")
    .trim();

  return cleanName;
};